
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/news",
      function () {
        return require("private-next-pages/d/news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/news"])
      });
    }
  